import { useState, type FC } from 'react';
import { type RegistrationItem, type GroupRegistration } from '@/api/registration/groupRegistration';
import QueryContainer from '@/base/QueryContainer/QueryContainer';
import {
  UiButton,
  UiHStack,
  UiIconPencilSimple, UiIconSwap,
  UiMenu,
  UiMenuButton,
  UiMenuItem,
  UiMenuList,
  UiStack,
  uiStyles,
  UiTable,
  UiTbody,
  UiTd,
  UiText,
  UiTh,
  UiThead,
  UiTr,
} from '@/lib/ui';
import { TableContainer, useDisclosure } from '@chakra-ui/react';
import { type UseQueryResult } from '@tanstack/react-query';
import ReAssignModal from './ReAssignModal';
import BaseButtonIconText from '@/base/Button/IconText';

interface GroupRegistrationProps {
  groupRegistrationQuery: UseQueryResult<GroupRegistration, Error>
}

const GroupAttendees: FC<GroupRegistrationProps> = ({ groupRegistrationQuery }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selectedRegistration, setSelectedRegistration] = useState<RegistrationItem | null>(null);
  const handleCloseModal = () => {
    setSelectedRegistration(null);
    onClose();
  };
  const handleReassign = (regis: RegistrationItem) => {
    setSelectedRegistration(regis);
    onOpen();
  };
  return (
    <QueryContainer query={groupRegistrationQuery} errorMessage="Failed to load group registration data.">
      {(groupRegistration) => {
        const { id: groupRegistrationId } = groupRegistration;
        return (
          <UiStack spacing={4}>
            <UiHStack justifyContent={'space-between'}>
              <UiText fontWeight={'bold'}>
                Attendees
              </UiText>
            </UiHStack>
            <UiStack
              p={8}
              bgColor={'#fff'}
              borderRadius={uiStyles.borderRadius}
              // shadow={uiStyles.cardShadow}
              shadow={'none'}
              borderColor={'gray.300'}
              borderWidth={'1px'}
              borderStyle={'solid'}
            >
              <TableContainer>
                <UiTable>
                  <UiThead>
                    <UiTr>
                      <UiTh>
                        <UiText variant='body2' alignContent={'center'}>
                          Name
                        </UiText>
                      </UiTh>
                      <UiTh>
                        <UiText variant='body2' alignContent={'center'}>
                          Email
                        </UiText>
                      </UiTh>
                      <UiTh>
                        <UiText variant='body2' alignContent={'center'}>
                          Registration Type
                        </UiText>
                      </UiTh>
                      <UiTh>
                        <UiText variant='body2' alignContent={'center'}>
                          Status
                        </UiText>
                      </UiTh>
                      <UiTh>
                        <UiText variant='body2' alignContent={'center'}>
                          Actions
                        </UiText>
                      </UiTh>
                    </UiTr>
                  </UiThead>
                  <UiTbody>
                    {groupRegistration.registrations.map((registration) => {
                      return (
                        <UiTr key={registration.id}>
                          <UiTd>
                            <UiText variant='body2' alignContent={'center'}>
                              {registration.name}
                            </UiText>
                          </UiTd>
                          <UiTd>
                            <UiText variant='body2' alignContent={'center'}>
                              {registration.email}
                            </UiText>
                          </UiTd>
                          <UiTd>
                            <UiText variant='body2' alignContent={'center'}>
                              {registration.registrationType}
                            </UiText>
                          </UiTd>
                          <UiTd>
                            <UiText variant='body2' alignContent={'center'}>
                              {registration.status}
                            </UiText>
                          </UiTd>
                          <UiTd>
                            <BaseButtonIconText Icon={UiIconSwap} onClick={() => { handleReassign(registration); }}>Reassign</BaseButtonIconText>
                            {/*<UiMenu>*/}
                            {/*  <UiMenuButton isActive={isOpen}*/}
                            {/*    as={UiButton}*/}
                            {/*  >*/}
                            {/*    Action*/}
                            {/*  </UiMenuButton>*/}
                            {/*  <UiMenuList>*/}
                            {/*    <UiMenuItem onClick={() => { handleReassign(registration); }}>Reassign</UiMenuItem>*/}
                            {/*  </UiMenuList>*/}
                            {/*</UiMenu>*/}
                          </UiTd>
                        </UiTr>
                      );
                    })}
                  </UiTbody>
                </UiTable>
              </TableContainer>
            </UiStack>
            <ReAssignModal
              isOpen={isOpen}
              groupRegistrationId={groupRegistrationId}
              onClose={handleCloseModal}
              selectedRegistration={selectedRegistration}
            />
          </UiStack>
        );
      }}
    </QueryContainer >
  );
};

export default GroupAttendees;
